import React from "react";
import { useSelector, useDispatch } from "react-redux";

//STYLES
import * as PageNavigationButtonsStyles from "./styles/pageNavigationButtons";

//ACTIONS
import * as NavBarActions from "../../../envStore/actions/navBar";

function PageNavigationButtons(props) {
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);
    const navBarSettings = useSelector((state) => state.navBar);
    const dispatch = useDispatch();

    function changePosition(direction) {
        dispatch(NavBarActions.moveSitePosition(direction));
    }

    return (
        <div>
            {navBarSettings.showButtons && (
                <div>
                    {GS_generalSettings.isMobile ? (
                        <div style={PageNavigationButtonsStyles.navBottomsContainer}>
                            {navBarSettings.sitePosition != 0 && (
                                <div style={PageNavigationButtonsStyles.mobile_upArrowContainer} onClick={changePosition.bind(this, "up")}>
                                    <i className="fa-solid fa-angle-up fa-3x"></i>
                                    <p style={PageNavigationButtonsStyles.arrowText}>{props.upText != "" && props.upText}</p>
                                </div>
                            )}
                            {navBarSettings.sitePosition != -500 && (
                                <div style={PageNavigationButtonsStyles.mobile_downArrowContainer} onClick={changePosition.bind(this, "down")}>
                                    <i className="fa-solid fa-angle-down fa-3x"></i>
                                    <p style={PageNavigationButtonsStyles.arrowText}>{props.downText != "" && props.downText}</p>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={PageNavigationButtonsStyles.navBottomsContainer}>
                            {navBarSettings.sitePosition != 0 && (
                                <div style={PageNavigationButtonsStyles.upArrowContainer} onClick={changePosition.bind(this, "up")}>
                                    <p style={PageNavigationButtonsStyles.arrowText}>
                                        <i className="fa-solid fa-angle-up fa-1x"></i>
                                        {props.upText != "" && props.upText}
                                    </p>
                                </div>
                            )}
                            {navBarSettings.sitePosition != -500 && (
                                <div style={PageNavigationButtonsStyles.downArrowContainer} onClick={changePosition.bind(this, "down")}>
                                    <p style={PageNavigationButtonsStyles.arrowText}>
                                        <i className="fa-solid fa-angle-down fa-1x"></i>
                                        {props.downText != "" && props.downText}
                                    </p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default PageNavigationButtons;
